import React from 'react';
import { AlertTriangle, Clock, Activity, ZapOff } from 'lucide-react';
export function AgitationSection() {
  const causes = [{
    id: 1,
    icon: <AlertTriangle className="w-6 h-6 text-emerald-600" data-id="element-1" />,
    title: 'Azúcar escondida en alimentos saludables',
    desc: 'Picos de insulina → más antojos → más inflamación'
  }, {
    id: 2,
    icon: <ZapOff className="w-6 h-6 text-emerald-600" data-id="element-2" />,
    title: 'Combinaciones que frenan tu metabolismo',
    desc: 'Tu sistema digestivo trabaja el doble y falla'
  }, {
    id: 3,
    icon: <Clock className="w-6 h-6 text-emerald-600" data-id="element-3" />,
    title: 'Horarios que alteran tus hormonas',
    desc: 'Tu cuerpo acumula en lugar de procesar'
  }, {
    id: 4,
    icon: <Activity className="w-6 h-6 text-emerald-600" data-id="element-4" />,
    title: 'Estrés que bloquea tu digestión',
    desc: 'El cortisol inflama desde adentro sin que comas nada malo'
  }];
  return <section className="py-20 bg-emerald-50/50" data-id="element-5">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6">
        <div className="max-w-5xl mx-auto" data-id="element-7">
          <div className="text-center mb-16" data-id="element-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-9">
              El problema no es lo que comés.
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-4" data-id="element-10">
              Es cómo lo combinás, cuándo lo comés… y en qué estado está tu
              digestión cuando lo recibe.
            </p>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-11">
              Podés estar comiendo lechuga, pollo y fruta — lo más sano del
              mundo — y aun así inflamarte.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-12">
            {causes.map(cause => <div key={cause.id} className="bg-white p-6 rounded-xl shadow-sm border border-emerald-100 hover:shadow-md transition-shadow" data-id="element-13">
                <div className="flex items-start gap-4" data-id="element-14">
                  <div className="bg-emerald-100 p-3 rounded-full flex-shrink-0" data-id="element-15">
                    {cause.icon}
                  </div>
                  <div data-id="element-16">
                    <div className="flex items-center gap-2 mb-2" data-id="element-17">
                      <span className="bg-emerald-600 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-18">
                        #{cause.id}
                      </span>
                      <h3 className="font-bold text-gray-900" data-id="element-19">{cause.title}</h3>
                    </div>
                    <p className="text-gray-600" data-id="element-20">{cause.desc}</p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="text-center" data-id="element-21">
            <p className="text-2xl font-serif italic text-emerald-900" data-id="element-22">
              "No es rebeldía. No es falta de voluntad. No es tu culpa.{' '}
              <br className="hidden md:block" data-id="element-23" />
              <span className="font-bold not-italic border-b-4 border-emerald-200" data-id="element-24">
                Es biología. Y tiene solución.
              </span>
              "
            </p>
          </div>
        </div>
      </div>
    </section>;
}